/**
 * parallax
 * @author PLEJ
 */

const iphoneDetector = (() => {
  const init = () => {
    const iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
    iOS && document.querySelector("body").classList.add("is-iphone");
  };

  return {
    init: init
  };
})();

export { iphoneDetector };
